import { useEffect } from 'react';
import { useBrowserStorage } from '#hooks/useBrowserStorage.ts';
import { useUrlParam } from '#hooks/useUrlParam.ts';

/**
 * Check if the user wants to sign up for the Pro plan by looking at the 'plan' query param,
 * then if so, save it to localStorage.
 *
 * @returns the requested plan flag and a function to clear the localStorage record
 */
export function useRequestedPlan() {
  const [planParam, setPlanParam] = useUrlParam('plan');
  const [requestedPlanFlag, setRequestedPlanFlag, clearRequestedPlanFlag] = useBrowserStorage<string>(
    'requested-plan',
    'local'
  );

  useEffect(() => {
    if (planParam) {
      setRequestedPlanFlag(planParam);
      setPlanParam(undefined);
    }
  }, [planParam, requestedPlanFlag, setPlanParam, setRequestedPlanFlag]);

  return [requestedPlanFlag, clearRequestedPlanFlag] as const;
}
